module.exports = __webpack_public_path__ + "img/75.7.Chla.b3ad89a4.png";